import { Col, Row, Text } from 'components';
import styled, { css, keyframes } from 'styled-components';

const progress = keyframes`
 from { width: 0%; }
 to { width: 100%; }
`;

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 70px;
  background: linear-gradient(180deg, rgba(38, 38, 38, 0.8) 0%, rgba(38, 38, 38, 0) 100%);
`;

const Bars = styled.div`
  flex: 1;
  padding: 10px 16px 8px;
  justify-content: center;
  z-index: 10;
  display: flex;
  gap: 4px;
`;

const Bar = styled.div`
  height: 2px;
  max-width: 100%;
  background-color: ${(props) => (props.hasPassed ? '#fff' : 'rgba(255, 255, 255, .35)')};
  border-radius: 2px;
  flex: 1;
  position: relative;
`;

const Progress = styled.div`
  top: 0;
  left: 0;
  height: 2px;
  background-color: #fff;

  ${(props) =>
    !props.hasPassed &&
    props.isCurrent &&
    css`
      animation: ${progress} ${props.duration}ms linear;
    `};
  ${(props) =>
    !props.hasPassed &&
    css`
      width: 0%;
    `}
  animation-play-state: ${(props) => (props.paused ? 'paused' : 'running')};
`;

const Avatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 40px;
`;

let animationId;
const Header = ({ data, index, user, paused }) => {
  const containerId = `hl-cont-${index}`;
  const barId = `hl-bar-${index}`;

  return (
    <Container>
      <Bars>
        {data?.map((item, i) => (
          <Bar key={item._id} hasPassed={i < index} id={containerId}>
            <Progress
              id={barId}
              isCurrent={i === index}
              hasPassed={i < index}
              duration={item.duration || 15000}
              paused={paused}
            />
          </Bar>
        ))}
      </Bars>

      <Row pad="0 16px">
        <Avatar src={user.avatar} />

        <Col center noFlex marg="0 0 0 8px">
          <Text b2 bold col="#fff">
            {user?.name}
          </Text>
          <Text marg="0 0 0" c1 col="#fff">
            @{user?.username}
          </Text>
        </Col>
      </Row>
    </Container>
  );
};

export default Header;
